const { apiCall } = require('./utils.js');
var moment = require('moment-timezone');

class AgendaReschedule {
    constructor(data, cb) {
        console.log('Agenda ReSchedule', data, cb);

        this.isHunterReschedule = false;
        this.callBack = cb;
        this.reScheeduleData = {
            branchId: false,
            patientType: false,
            oldData: data,
            newData: false
        };
        this.reScheduleDone = false;

        if (data[0].name.indexOf('hunter') !== -1) {
            this.isHunterReschedule = true;
        }
        //console.log("data[0].name.indexOf('hunter')", data[0].name.indexOf('hunter'));

        let businessBranchId = false,
            scheduleAgendaId = false, // Não precisa pq é agendamento?
            scheduleStartHour = false, // Não precisa pq é agendamento?
            scheduleEndHour = false, // Não precisa pq é agendamento?
            scheduleDoctor = false, // Não precisa pq é agendamento?
            scheduleService = false, // Não precisa pq é agendamento?
            scheduleCustomerName = false, // Não precisa pq é agendamento?
            scheduleCustomerWhatsApp = false, // Não precisa pq é agendamento?
            scheduleCustomerAgendaId = false, // Não precisa pq é agendamento?
            scheduleCustomerWhatsAppInt = false; // Não precisa pq é agendamento?

        for(let i in data) {
            let info = data[i];
            let prefix = this.isHunterReschedule ? `hunter_agenda_edit` : `agenda_edit`;
            console.log('prefix', prefix);
            console.log('info', info);
            if (info.name == `${prefix}_business_branch`) {
                this.reScheeduleData.branchId = info.value;
            }
            if (info.name == `${prefix}_patient_type`) {
                this.reScheeduleData.patientType = info.value;
            }
            if (info.name == `${prefix}_schedule_agenda_id`) {
                scheduleAgendaId = info.value;
            }
        }
        //console.log('this.reScheeduleData.branchId', this.reScheeduleData.branchId);
        //console.log('this.reScheeduleData.patientType', this.reScheeduleData.patientType);
        //console.log('scheduleAgendaId', scheduleAgendaId);
        $('#agenda_reschedule_business_branch').val(this.reScheeduleData.branchId);
        $('.js-agenda-reschedule-dialog-title-id').html(scheduleAgendaId);

        const dateInput = document.getElementById('agenda_reschedule_date'); // Get the date input element
        const today = new Date().toISOString().split('T')[0]; // Get today's date
        dateInput.setAttribute('min', today); // Set the minimum date to today

        this.bindDomChanges();
    }

    bindDomChanges() {
        let self = this;
        $(document).on('change', '#agenda_reschedule_date', function() {
            let currentAgendaEditDate = $(this).val();
            $(".modal-agenda-reschedule-dialog").block(window._loader.loading);

            apiCall({
                endpoint: 'api/v1/employee/agenda',
                method: 'POST',
                data: {
                    start: currentAgendaEditDate,
                    end: currentAgendaEditDate,
                    branchId: self.reScheeduleData.branchId,
                    doctorId: 0,
                    isCalendar: false
                },
                successCallback: function(res) {
                    console.log('update_agenda_schedule.js/employee/agenda', '#agenda_reschedule_date', res);
                    $(".modal-agenda-reschedule-dialog").unblock()
                    
                    if (!res.error) {
                        let html = '<option selected default value="">-- Selecione --</option>';
                        for(let i in res.data) {
                            let avaiDoctorHour = res.data[i];
                            let 
                                selectedStartDate = $('#agenda_reschedule_date').val(),
                                todayDate = moment().tz('America/Sao_Paulo'),
                                selectedStartDateMoment = moment(selectedStartDate).tz('America/Sao_Paulo'),
                                startHourMinute = avaiDoctorHour.HORA_INICIO_FORMATED.split(':'),
                                startDate = selectedStartDateMoment.set({'hours': parseInt(startHourMinute[0]), 'minutes': parseInt(startHourMinute[1]), 'seconds': 0}),
                                isDisabled = false;

                            if (selectedStartDateMoment.format('YYYY-MM-DD') == todayDate.format('YYYY-MM-DD') && 
                                todayDate.unix() > startDate.unix()) {
                                    isDisabled = true;
                            }

                            if (avaiDoctorHour.CATEGORIA.indexOf(self.reScheeduleData.patientType) !== -1) {
                                html += `
                                    <option value="${avaiDoctorHour.HORA_INICIO_FORMATED}" data-agenda-id="${avaiDoctorHour.ID}" data-doctor-id="${avaiDoctorHour.DOUTORES_ID}" ${isDisabled ? 'disabled' : ''}>
                                    ${avaiDoctorHour.HORA_INICIO_FORMATED} | ${avaiDoctorHour.CATEGORIA} | ${avaiDoctorHour.DOUTOR_NOME}
                                    </option>
                                `;
                            }
                        }
                        $('#agenda_reschedule_start_hour').prop('disabled', false);
                        $('#agenda_reschedule_start_hour').html(html);

                        console.log('update_agenda_schedule.js/employee/agenda', '#agenda_reschedule_date', res.data);
                    }
                },
                errorCallback: function(res) {
                    $(".modal-agenda-reschedule-dialog").block(window._loader.error);
                }
            });
        });

        $(document).on('change', '#agenda_reschedule_start_hour', function() {
            let selectedStartHour = $(this).val();
            console.log('selectedStartHour', selectedStartHour);
            console.log("$('#agenda_reschedule_start_hour option:selected').data('doctor-id')", $('#agenda_reschedule_start_hour option:selected').data('doctor-id'));
            // Caso o horário selecionado seja válido, carrega lista de serviços
            if (selectedStartHour != '') {
                $('#agenda_reschedule_doctor').val($('#agenda_reschedule_start_hour option:selected').data('doctor-id'));
            }
        });

        $(document).on('submit', '.js-agenda-reschedule', function(e) {
            e.preventDefault();
            let data = $(this).serializeArray(),
                scheduleSelectedAgendaId = $('#agenda_reschedule_start_hour option:selected').data('agenda-id');

            data.push({
                name: 'agenda_reschedule_agenda_id',
                value: scheduleSelectedAgendaId
            });
            self.reScheeduleData.newData = data;
            
            apiCall({
                method: 'POST',
                endpoint: 'api/v1/doctor/agenda/mark_as_rescheduled',
                data: self.reScheeduleData,
                formBlockContainer: ".modal-agenda-reschedule-dialog",
                formElement: ".js-agenda-reschedule",
                successCallback: function(res) {
                    console.log('update_agenda_schedule.js/doctor/agenda/mark_as_not_attended', '.js-agenda-reschedule', res);

                    if (res.error) {
                        self.reScheduleDone = false;
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        self.reScheduleDone = true;
                        window.toast({
                            error: false,
                            text: res.message
                        })
                        $('.js-agenda-reschedule').trigger('reset');
                        $('.js-reschedule-dialog-close').trigger('click');
                    }
                },
                errorCallback: function(err) {
                    self.reScheduleDone = false;
                    //$(".modal-update-event-manager").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                    console.error('ERROR', 'update_agenda_schedule.js/doctor/agenda/mark_as_not_attended', '.js-agenda-reschedule', err);
                }
            })
        });

        $("#modal-agenda-reschedule").on("hidden.bs.modal", function () {
            $(document).off('change', '#agenda_reschedule_date');
            $(document).off('change', '#agenda_reschedule_start_hour');
            $(document).off('submit', '.js-agenda-reschedule');

            // put your default event here
            $('.js-agenda-reschedule').trigger('reset');
            $('#agenda_reschedule_start_hour').html('');
            self.callBack(self.reScheduleDone);
        });
    }
}
module.exports = AgendaReschedule